/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import {
        connect,
        createObjectId,
} from 'pow-mongodb-fixtures';
import mongodbURI from 'mongodb-uri';
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../events', () => {
        const mongo = mongodbURI.parse(process.env.CLIO_MONGO_URL);
        const fixtures = connect(mongo.database, {
                host: mongo.hosts[0].host,
                port: mongo.hosts[0].port,
                user: mongo.username,
                pass: mongo.password,
        });
        const dataAPI = new DataAPI();
        const id = '123456789a123456789b1234';
        const index = 0;

        before(function before(done) {
                this.timeout(5000);
                fixtures.clearAllAndLoad({
                        cameras: [{
                                _id: createObjectId(id),
                                public_address: '123.123.123.123',
                                web_port: 80,
                                username: 'onvif',
                                password: 'onvif',
                                streams: {
                                        0: {
                                                rtsp_url: 'rtsp://url',
                                                rate_control: {
                                                        frame_rate_limit: 30,
                                                },
                                                h264: {
                                                        gov_length: 15,
                                                },
                                        },
                                },
                        }],
                }, (err) => {
                        if (err) {
                                throw new Error(err.message);
                        }
                        dataAPI.initialize({
                                environment: 'unit-test',
                                heartbeatInterval: 10,
                                logLevel: 'DEBUG',
                                mongoUrl: process.env.CLIO_MONGO_URL,
                                port: 15925,
                        });
                        dataAPI.start(done);
                });
        });

        it('POST existing stream should succeed', (done) => {
                request(dataAPI.expressApp)
                .post(`/cameras/${id}/streams/${index}/events`)
                .send({
                        type: 'DIO',
                        time: 1470296111425,
                })
                .expect(200)
                .end(/** @type function */done);
        });

        it('POST existing stream should succeed', (done) => {
                request(dataAPI.expressApp)
                .put(`/cameras/${id}/streams/${index}/events?time=1470296111425`)
                .send({
                        videoInfo: {
                                status: 'uploaded',
                                startTime: 1474250357286,
                                endTime: 1474250367286,
                                bucketName: 'io-arisan-clio-sandbox-test',
                                objectName: 'path/to/obj.mp4',
                                streamId: '567da100f2f90000011fa0c5_0',
                        },
                })
                .expect(200)
                .end(/** @type function */done);
        });
        after(done => dataAPI.stop(done));
});
